import { ImageProps } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { Image } from '@/components/HOC/Image'
import SpinnerImage from '@/public/assets/images/spinner.png'

export const Spinner = (props: ImageProps) => {
  return (
    <motion.div
      animate={{
        rotate: 360,
      }}
      transition={{ ease: 'linear', duration: 1.25, repeat: Infinity }}
    >
      <Image {...props} src={SpinnerImage} alt={''} />
    </motion.div>
  )
}
